// SystemEnvContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const SystemEnvContext = createContext();

const LOCAL_STORAGE_KEY = "curServer";

// localStorage에서 값 가져오기 (없으면 초기값 반환)
function getInitialEnv() {
    try {
        const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
        return stored ? JSON.parse(stored) : { key: "prod" }; // 원하는 기본값
    } catch {
        return { key: "prod" };
    }
}

export function SystemEnvProvider({ children }) {
    const [env, setEnv] = useState(getInitialEnv);

    // env가 바뀔 때마다 localStorage에도 저장
    useEffect(() => {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(env));
    }, [env]);

    return (
        <SystemEnvContext.Provider value={{ env, setEnv }}>
        {children}
        </SystemEnvContext.Provider>
    );
    }

export function useSystemEnv() {
    return useContext(SystemEnvContext);
}
